import { useMemo } from 'react'
import { type EditorRequest, type RequestComment } from './revisionRequest'

// The comments the editor shows under each row: the manager's revision
// request plus a sent-back review's cell comments, keyed by row id.
export function useRowNotes(request: EditorRequest | null | undefined, review: RequestComment[] | undefined) {
  return useMemo(() => {
    const map: Record<string, RequestComment[]> = {}
    ;[...(request?.comments ?? []), ...(review ?? [])].forEach((c) => {
      if (c.row_id) (map[c.row_id] ??= []).push(c)
    })
    return map
  }, [request, review])
}
